import { render, staticRenderFns } from "./ReorderReportList.vue?vue&type=template&id=2c004798&scoped=true"
import script from "./ReorderReportList.vue?vue&type=script&lang=js"
export * from "./ReorderReportList.vue?vue&type=script&lang=js"
import style0 from "./ReorderReportList.vue?vue&type=style&index=0&id=2c004798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c004798",
  null
  
)

export default component.exports